// You must use "us-east-1" as the region for Chime API and set the endpoint.
export const CHIME_REGION = 'us-east-1';

export const CHIME_ENDPOINT = 'https://service.chime.aws.amazon.com/console';
